export const platformAppName = 'Platform';
export const billingAppName = 'Billing';
export const orderTrackerAppName = 'Order Tracker';
export const supportEnquiryAppName = 'Channel Care';
export const networkPerformanceReports = 'Network Performance Reports';
export const mobileDataUsageMeterAppName = 'Mobile Data Usage Meter';
export const mobilityAppName = 'Mobility';
export enum UserType {
    customerUser = 'customer_user',
    staffUser = 'staff_user'
}
